module.exports = __webpack_public_path__ + "static/img/tab2.e94aeb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/tab2.png
// module id = m3ak
// module chunks = 1